export const PAYMENT_TERM_IDS = Object.freeze({
  MANUAL: 1,
  CASH: 2,
  THIRTY_DAYS_NET: 3,
  FOURTEEN_DAYS_NET: 4
})

function getDepositDescription () {
  if (this.id === PAYMENT_TERM_IDS.MANUAL) {
    return 'En handpenning kan läggas till när fakturan skapas.'
  }

  const hasDeposit = this.deposit_date != null ||
    this.deposit_days_before_checkin != null ||
    this.deposit_days_from_invoicing != null
  if (!hasDeposit) {
    return 'Ingen handpenning tas ut.'
  }

  const formatAmount = amount => window.conversion.toHumanReadableAmount(amount / 100)
  let amountDescription = this.deposit_amount != null
    ? formatAmount(this.deposit_amount)
    : `${this.deposit_percent} %`

  if (this.include_non_refundable_charges_in_deposit) {
    amountDescription += ' plus ej återbetalningsbara avgifter'
  }
  if (this.deposit_amount == null && this.deposit_min_amount != null) {
    amountDescription += `, dock minst ${formatAmount(this.deposit_min_amount)}`
  }

  let dueDateDescription
  if (this.deposit_date) {
    const depositDate = window.dayjs.parseServerDate(this.deposit_date).format('D MMM YYYY')
    dueDateDescription = `förfaller den ${depositDate}`
  } else if (this.deposit_days_before_checkin != null) {
    dueDateDescription = `förfaller ${this.deposit_days_before_checkin} dagar före incheckning`
  } else if (this.deposit_days_from_invoicing === 0) {
    dueDateDescription = 'förfaller på fakturadagen'
  } else {
    dueDateDescription = `förfaller ${this.deposit_days_from_invoicing} dagar efter fakturering`
  }

  return `Handpenningen är ${amountDescription} och ${dueDateDescription}. Om slutbetalningen skulle understiga 100 kr, eller handpenningen inte kan förfalla före slutbetalningen, förfaller hela beloppet på det tidigare datumet, dock tidigast på fakturadagen.`
}

function getDueDateDescription () {
  if (this.id === PAYMENT_TERM_IDS.MANUAL) {
    return 'Förfallodatum och eventuell handpenning väljs manuellt när fakturan skapas.'
  }
  if (this.id === PAYMENT_TERM_IDS.CASH) {
    return 'Fakturan förfaller på fakturadagen.'
  }

  const subject = this.deposit_date != null ||
    this.deposit_days_before_checkin != null ||
    this.deposit_days_from_invoicing != null
    ? 'Slutbetalningen'
    : 'Fakturan'

  let description
  if (this.due_date_date) {
    const dueDate = window.dayjs.parseServerDate(this.due_date_date).format('D MMM YYYY')
    description = `${subject} förfaller den ${dueDate}.`
  } else if (this.due_date_days_before_checkin != null) {
    const relativeDateDescription = this.due_date_days_before_checkin === 0
      ? 'på incheckningsdagen'
      : `${this.due_date_days_before_checkin} dagar före incheckning`
    const minimumDateDescription = this.min_days_due_date == null || this.min_days_due_date === 0
      ? 'dock tidigast på fakturadagen'
      : `dock tidigast ${this.min_days_due_date} dagar efter fakturering`
    description = `${subject} förfaller ${relativeDateDescription}, ${minimumDateDescription}.`
  } else if (this.due_date_days_from_invoicing === 0) {
    description = `${subject} förfaller på fakturadagen.`
  } else {
    description = `${subject} förfaller ${this.due_date_days_from_invoicing} dagar efter fakturering.`
  }

  if (this.latest_due_date_days_before_checkin == null) {
    return description
  }

  const latestDueDateDescription = this.latest_due_date_days_before_checkin === 0
    ? 'på incheckningsdagen'
    : `${this.latest_due_date_days_before_checkin} dagar före incheckning`
  return `${description} För fakturor med bokning är förfallodatumet senast ${latestDueDateDescription}.`
}

function getPaymentTermDescription () {
  const description = `${getDueDateDescription.call(this)} ${getDepositDescription.call(this)}`
  if (!this.custom_invoice_text) {
    return description
  }

  return `${description} Särskilda betalvillkor: ${this.custom_invoice_text}`
}

export default {
  getDepositDescription,
  getDueDateDescription,
  getPaymentTermDescription
}
